import { useState, useEffect } from "react";
import styles from "./detalhe.module.css";
import Sidebar from "../../Components/Sidebar";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import api from "../../api";

const ICONE = { curtida: "👍", amei: "❤️", comentario: "💬", visualizacao: "👁️" };
const LABEL = { curtida: "Curtiu", amei: "Amei", comentario: "Comentou", visualizacao: "Visualizou" };

const TIPO_MAP = { amecom: "amei" };

function normalizarTipo(tipo) {
    const t = (tipo ?? "").toLowerCase();
    return TIPO_MAP[t] ?? t;
}

const COR_AVATAR = [
    "#e11d48", "#7c3aed", "#0284c7", "#059669",
    "#d97706", "#db2777", "#2563eb", "#16a34a",
];

function corAvatar(nome = "") {
    const idx = nome.charCodeAt(0) % COR_AVATAR.length;
    return COR_AVATAR[idx];
}

function iniciais(nome = "") {
    return nome.split(" ").slice(0, 2).map(p => p[0]).join("").toUpperCase();
}

function isAgendadoPendente(item) {
    if (item?.tipcom !== "agendado") return false;
    if (!item?.datcom) return true;
    const [d, m, y] = item.datcom.split("/");
    const hora = (item.horcom || "00:00").slice(0, 5);
    return new Date(`${y}-${m}-${d}T${hora}`) > new Date();
}

function isArquivado(item) {
    if (!item?.datarq) return false;
    const partes = item.datarq.split("/");
    if (partes.length !== 3) return false;
    const [d, m, y] = partes;
    const dataArq = new Date(parseInt(y), parseInt(m) - 1, parseInt(d));
    const hoje = new Date();
    hoje.setHours(0, 0, 0, 0);
    return dataArq <= hoje;
}

export default function DetalheComunicado() {
    const { id } = useParams();
    const navigate = useNavigate();
    const location = useLocation();

    const [comunicado] = useState(location.state?.comunicado ?? null);
    const [interacoes, setInteracoes] = useState([]);
    const [loadingInteracoes, setLoadingInteracoes] = useState(false);
    const [paginaTimeline, setPaginaTimeline] = useState(1);
    const [filtroNome, setFiltroNome] = useState("");
    const [filtroData, setFiltroData] = useState("");
    const ITENS_TIMELINE = 6;

    async function carregarInteracoes() {
        try {
            setLoadingInteracoes(true);
            // TODO: substituir pela URL do endpoint de linha do tempo quando estiver pronto
            // Retorno esperado: array de { tipo, nome, datahora, texto? }
            // tipo: "curtida" | "amei" | "comentario" | "visualizacao"
             const res = await api.get(`/portal/interacoes/?codcom=${id}`);
             setInteracoes(Array.isArray(res.data)
                ? res.data.map(i => ({ ...i, tipo: normalizarTipo(i.tipo) }))
                : []);
            //setInteracoes([]);
        } catch (error) {
            setInteracoes([]);
        } finally {
            setLoadingInteracoes(false);
        }
    }

    useEffect(() => {
        carregarInteracoes();
    }, [id]);

    const interacoesFiltradas = interacoes.filter(i => {
        const nomeOk = filtroNome === "" || (i.nomfun ?? "").toLowerCase().includes(filtroNome.toLowerCase());
        const dataOk = filtroData === "" || (i.datint ?? "").includes(toDDMMYYYY(filtroData));
        return nomeOk && dataOk;
    });

    function toDDMMYYYY(iso) {
        if (!iso) return "";
        const [y, m, d] = iso.split("-");
        return `${d}/${m}/${y}`;
    }

    function handleLimparFiltro() {
        setFiltroNome("");
        setFiltroData("");
        setPaginaTimeline(1);
    }

    const totalPaginasTimeline = Math.ceil(interacoesFiltradas.length / ITENS_TIMELINE);
    const interacoesPagina = interacoesFiltradas.slice(
        (paginaTimeline - 1) * ITENS_TIMELINE,
        paginaTimeline * ITENS_TIMELINE
    );

    return (
        <div className={styles.layout}>
            <Sidebar />
            <div className={styles.main}>
                <div className={styles.content}>

                    {/* TOPO */}
                    <div className={styles.topBar}>
                        <div>
                            <span className={styles.pageLabel}>Comunicação · Comunicados</span>
                            <h1 className={styles.pageTitle}>Detalhes do Comunicado</h1>
                        </div>
                        <button className={styles.btnVoltar} onClick={() => navigate("/comunicados")}>
                            ← Voltar para lista
                        </button>
                    </div>

                    {!comunicado && (
                        <p className={styles.loading}>Comunicado não encontrado. <button className={styles.btnVoltar} onClick={() => navigate("/comunicados")}>Voltar para a lista</button></p>
                    )}

                    {comunicado && (
                        <>
                            {/* CABEÇALHO DO COMUNICADO */}
                            <div className={styles.cabecalho}>
                                <div className={styles.cabecalhoInfo}>
                                    <div className={styles.badgesRow}>
                                        {isAgendadoPendente(comunicado) && (
                                            <div className={styles.badgeAgendado}>
                                                🕐 Agendado
                                                <span>{comunicado.datcom}{comunicado.horcom ? ` às ${comunicado.horcom.slice(0, 5)}` : ""}</span>
                                            </div>
                                        )}
                                        {isArquivado(comunicado) && (
                                            <div className={styles.badgeArquivado}>
                                                📦 Arquivado
                                                <span>em {comunicado.datarq}</span>
                                            </div>
                                        )}
                                    </div>
                                    <h3 dangerouslySetInnerHTML={{ __html: comunicado.titcom }} />
                                    <div className={styles.metaRow}>
                                        <span className={styles.badge}>{comunicado.setcom}</span>
                                        <span className={styles.metaItem}>Grupo: {comunicado.grupo}</span>
                                        <span className={styles.metaItem}>📅 {comunicado.datcom}</span>
                                    </div>
                                </div>
                            </div>

                            {/* CARDS DE ESTATÍSTICAS */}
                            <div className={styles.statsRow}>
                                <div className={styles.statCard}>
                                    <span>👁️</span>
                                    <strong>{comunicado.viscom ?? 0}</strong>
                                    <small>Visualizações</small>
                                </div>
                                <div className={styles.statCard}>
                                    <span>👍</span>
                                    <strong>{comunicado.curtidas ?? 0}</strong>
                                    <small>Curtidas</small>
                                </div>
                                <div className={styles.statCard}>
                                    <span>❤️</span>
                                    <strong>{comunicado.ameis ?? 0}</strong>
                                    <small>Amei</small>
                                </div>
                                <div className={styles.statCard}>
                                    <span>💬</span>
                                    <strong>{comunicado.totalComentarios ?? comunicado.comentarios ?? 0}</strong>
                                    <small>Comentários</small>
                                </div>
                            </div>

                            {/* IMAGEM + CONTEÚDO LADO A LADO */}
                            {(comunicado.imagem || comunicado.concom) && (
                                <div className={styles.corpoRow}>
                                    {comunicado.imagem && (
                                        <div className={styles.imagemWrap}>
                                            <img src={comunicado.imagem} alt="" />
                                        </div>
                                    )}
                                    {comunicado.concom && (
                                        <div className={styles.corpoCard}>
                                            <h4>Conteúdo</h4>
                                            <div
                                                className={styles.corpoTexto}
                                                dangerouslySetInnerHTML={{ __html: comunicado.concom }}
                                            />
                                        </div>
                                    )}
                                </div>
                            )}
                        </>
                    )}

                    {/* TIMELINE DE INTERAÇÕES */}
                    <div className={styles.timelineCard}>
                        <div className={styles.timelineCardHeader}>
                            <h4>Histórico de Interações</h4>
                            {interacoes.length > 0 && (
                                <span className={styles.totalBadge}>{interacoes.length} registros</span>
                            )}
                        </div>

                        {/* FILTROS DA TIMELINE */}
                        {interacoes.length > 0 && (
                            <div className={styles.filtrosBar}>
                                <div className={styles.filtroGrupo}>
                                    <label>Nome</label>
                                    <input
                                        type="text"
                                        placeholder="Buscar por nome..."
                                        value={filtroNome}
                                        onChange={e => { setFiltroNome(e.target.value); setPaginaTimeline(1); }}
                                    />
                                </div>
                                <div className={styles.filtroGrupo}>
                                    <label>Data da interação</label>
                                    <input
                                        type="date"
                                        value={filtroData}
                                        onChange={e => { setFiltroData(e.target.value); setPaginaTimeline(1); }}
                                    />
                                </div>
                                {(filtroNome || filtroData) && (
                                    <button className={styles.btnLimpar} onClick={handleLimparFiltro}>
                                        Limpar
                                    </button>
                                )}
                                {(filtroNome || filtroData) && (
                                    <span className={styles.resultadoBadge}>
                                        {interacoesFiltradas.length} resultado{interacoesFiltradas.length !== 1 ? "s" : ""}
                                    </span>
                                )}
                            </div>
                        )}

                        {loadingInteracoes && <p className={styles.loading}>Carregando interações...</p>}

                        {!loadingInteracoes && interacoesFiltradas.length === 0 && (
                            <p className={styles.vazio}>
                                {interacoes.length === 0 ? "Nenhuma interação registrada." : "Nenhum resultado para o filtro aplicado."}
                            </p>
                        )}

                        <div className={styles.timeline}>
                            {interacoesPagina.map((item, index) => (
                                <div key={index} className={styles.timelineItem}>
                                    <div
                                        className={styles.avatar}
                                        style={{ background: corAvatar(item.nomfun) }}
                                    >
                                        {iniciais(item.nomfun)}
                                    </div>
                                    <div className={styles.timelineContent}>
                                        <p>
                                            <strong>{item.nomfun}</strong>
                                            <span className={styles.acao}> {LABEL[item.tipo] ?? item.tipo}</span>
                                        </p>
                                        {item.tipo === "comentario" && item.tipint && (
                                            <p className={styles.comentarioTexto}>"{item.tipint}"</p>
                                        )}
                                        <div className={styles.timelineMeta}>
                                            <span>{ICONE[item.tipo]} {LABEL[item.tipo] ?? item.tipo}</span>
                                            <span>{item.datint}</span>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>

                        {totalPaginasTimeline > 1 && (
                            <div className={styles.paginacao}>
                                <button
                                    className={styles.btnPagina}
                                    onClick={() => setPaginaTimeline(p => p - 1)}
                                    disabled={paginaTimeline === 1}
                                >
                                    ‹ Anterior
                                </button>

                                {Array.from({ length: totalPaginasTimeline }, (_, i) => i + 1).map(num => (
                                    <button
                                        key={num}
                                        className={`${styles.btnPagina} ${paginaTimeline === num ? styles.btnPaginaAtivo : ""}`}
                                        onClick={() => setPaginaTimeline(num)}
                                    >
                                        {num}
                                    </button>
                                ))}

                                <button
                                    className={styles.btnPagina}
                                    onClick={() => setPaginaTimeline(p => p + 1)}
                                    disabled={paginaTimeline === totalPaginasTimeline}
                                >
                                    Próximo ›
                                </button>
                            </div>
                        )}
                    </div>

                </div>
            </div>
        </div>
    );
}
